"use strict";
/**
 *
 * Component: Routes.tsx
 * Llenguatge: TypeScrypt
 * Autors:
 * Versió: 1.1
 * Data: 25/08/2017
 * (c) Ajuntament de Manresa - ago 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_1 = require("react-router");

var GenericRoute_1 = require("./GenericRoute");

var Routes = function Routes(props) {
  return React.createElement(react_router_1.Switch, null, props.routes.map(function (route, i) {
    var isLogged = props.isLogged;
    var tePermis = !route.permisMinim || route.permisMinim <= props.permis;
    return React.createElement(GenericRoute_1.default, __assign({
      key: i,
      isLogged: isLogged,
      tePermis: tePermis
    }, route));
  }));
};

exports.default = Routes;